module.exports = __webpack_public_path__ + "assets/chrome.f577fadc.svg";